class CartPriceSummary extends Component {
    constructor(el) {
        super(el);
        this.more = this.$find('[data-order-summary-more]');
        this.addEventListeners();
    }

    addEventListeners() {
        this.more.addEventListener('click', function () {
            this.$el.classList.toggle('is-open');
        }.bind(this));
    }
}